(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────────
     STRATEGY: The discount UI (pills + savings banner) is managed 100%
     via direct DOM manipulation — we do NOT rely on Shopify section swap
     to re-render it. Section swap is still used to refresh the cart-items
     table and cart-footer totals so prices update live.
  ───────────────────────────────────────────────────────────────────── */

  /* ── DOM helpers ──────────────────────────────────────────────────── */
  function $  (id)  { return document.getElementById(id); }
  function $$ (sel) { return document.querySelector(sel); }

  /* ── Section IDs (for refreshing cart table + footer totals only) ── */
  function getItemsSectionId() {
    var el = $('CartDiscountSection');
    return el ? el.dataset.sectionId : null;
  }
  function getFooterSectionId() {
    var el = $$('[id^="shopify-section-"][id*="cart-footer"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }
  function getSectionIds() {
    var ids = [];
    var sid = getItemsSectionId(); if (sid) ids.push(sid);
    var fid = getFooterSectionId(); if (fid) ids.push(fid);
    return ids;
  }

  /* ── Money formatting ─────────────────────────────────────────────── */
  function formatMoney(cents) {
    /* Use Shopify's own formatter if available */
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    /* Fallback: parse currency symbol from a known money element */
    var moneyEls = document.querySelectorAll('.price bdi, bdi');
    var symbol = 'TZS. ';
    if (moneyEls.length > 0) {
      var raw = moneyEls[0].textContent || '';
      var symMatch = raw.match(/^[^\d\s]+\s*/);
      if (symMatch) symbol = symMatch[0];
    }
    return symbol + (cents / 100).toFixed(2);
  }

  /* ── Compute total savings from cart API response ─────────────────── */
  function calcSavings(cartData) {
    var savings = 0;
    (cartData.items || []).forEach(function (item) {
      savings += (item.original_line_price || 0) - (item.final_line_price || 0);
    });
    (cartData.cart_level_discount_applications || []).forEach(function (d) {
      savings += d.total_allocated_amount || 0;
    });
    return savings;
  }

  /* ── Savings banner ───────────────────────────────────────────────── */
  function updateSavingsBanner(savings) {
    var banner = $('CartSavingsBanner');
    var amtEl  = $('CartSavingsAmount');
    if (!banner) return;
    if (savings > 0) {
      if (amtEl) amtEl.textContent = formatMoney(savings);
      banner.classList.add('is-visible');
    } else {
      banner.classList.remove('is-visible');
    }
  }

  /* ── Pill helpers ─────────────────────────────────────────────────── */
  function makePillHTML(code) {
    var safe = code.replace(/"/g, '&quot;').replace(/</g, '&lt;');
    return '<li class="cd-pill" data-code="' + safe + '">'
      + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>'
      + '<line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
      + safe.toUpperCase()
      + '<button type="button" form="" class="cd-pill-remove" data-code="' + safe + '" aria-label="Remove ' + safe + '">&times;</button>'
      + '</li>';
  }

  function addPill(code) {
    var list = $('CartDiscountPills');
    if (!list) return;
    /* Avoid duplicates */
    if (list.querySelector('[data-code="' + code + '"]')) return;
    list.insertAdjacentHTML('beforeend', makePillHTML(code));
  }

  function removePillFromDOM(code) {
    var list = $('CartDiscountPills');
    if (!list) return;
    var pill = list.querySelector('[data-code="' + code + '"]');
    if (pill) pill.remove();
  }

  function currentCodes() {
    var list = $('CartDiscountPills');
    if (!list) return [];
    return Array.from(list.querySelectorAll('.cd-pill[data-code]'))
      .map(function (el) { return el.dataset.code; })
      .filter(Boolean);
  }

  /* ── Feedback ─────────────────────────────────────────────────────── */
  function showFeedback(msg, type) {
    var el = $('CartDiscountFeedback');
    if (!el) return;
    el.textContent = msg;
    el.className   = 'cd-feedback is-visible ' + type;
  }
  function clearFeedback() {
    var el = $('CartDiscountFeedback');
    if (!el) return;
    el.textContent = '';
    el.className   = 'cd-feedback';
  }

  /* ── Loading state ────────────────────────────────────────────────── */
  function setLoading(yes) {
    var btn = $('CartDiscountApply');
    var inp = $('CartDiscountInput');
    if (btn) { btn.disabled = yes; btn.classList.toggle('is-loading', yes); }
    if (inp && !yes) inp.classList.remove('is-error');
  }

  /* ── Section swap (cart table + footer totals only) ──────────────── */
  function refreshSections(sections) {
    Object.keys(sections || {}).forEach(function (id) {
      var wrapperId = 'shopify-section-' + id;
      var live      = document.getElementById(wrapperId);
      if (!live) return;
      var parser  = new DOMParser();
      var newDoc  = parser.parseFromString(sections[id], 'text/html');
      var newNode = newDoc.getElementById(wrapperId);
      if (!newNode) return;

      /* Only swap the cart-items table, NOT the discount section */
      var liveTable = live.querySelector('.cart__items');
      var newTable  = newNode.querySelector('.cart__items');
      if (liveTable && newTable) liveTable.innerHTML = newTable.innerHTML;

      /* Swap footer (totals) entirely */
      if (id !== getItemsSectionId()) live.innerHTML = newNode.innerHTML;
    });
  }

  /* ── Shopify Cart API ─────────────────────────────────────────────── */
  function updateCartDiscount(codes) {
    return fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body:    JSON.stringify({ discount: codes.join(','), sections: getSectionIds() }),
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  /* ── Apply ────────────────────────────────────────────────────────── */
  function applyDiscount() {
    clearFeedback();
    var inp  = $('CartDiscountInput');
    var code = inp ? inp.value.trim().toUpperCase() : '';

    if (!code) {
      if (inp) inp.classList.add('is-error');
      showFeedback('Please enter a discount code.', 'is-error');
      return;
    }

    var existing = currentCodes();
    if (existing.some(function (c) { return c.toUpperCase() === code; })) {
      if (inp) inp.classList.add('is-error');
      showFeedback('Code "' + code + '" is already applied.', 'is-error');
      return;
    }

    setLoading(true);

    updateCartDiscount(existing.concat([code]))
      .then(function (data) {
        var discountCodes = data.discount_codes || [];

        /* ── Partition codes from the response ── */
        var newCodeEntry = discountCodes.find(function (d) {
          return d.code.toUpperCase() === code;
        });

        /* Codes that Shopify now says are NOT applicable (could be existing ones
           that got bumped out by the new code, or the new code itself) */
        var notApplicable = discountCodes.filter(function (d) {
          return d.applicable === false;
        });

        /* Codes that ARE applicable after this update */
        var applicable = discountCodes.filter(function (d) {
          return d.applicable !== false;
        });

        /* ── Case 1: new code itself is not applicable ── */
        if (!newCodeEntry || newCodeEntry.applicable === false) {

          /* Check if ANY existing code became non-applicable due to the new one.
             If yes → it's a "can't combine" conflict (new code is valid but clashes).
             If no  → the new code is simply invalid for this cart. */
          var existingBumped = notApplicable.some(function (d) {
            return existing.some(function (e) { return e.toUpperCase() === d.code.toUpperCase(); });
          });

          /* Revert cart back to only the applicable existing codes */
          var revertCodes = applicable
            .map(function (d) { return d.code; })
            .filter(function (c) { return c.toUpperCase() !== code; });

          return updateCartDiscount(revertCodes).then(function (revertData) {
            refreshSections(revertData.sections || {});
            updateSavingsBanner(calcSavings(revertData));

            /* Remove pills for any existing codes now marked not-applicable */
            notApplicable.forEach(function (d) {
              if (d.code.toUpperCase() !== code) removePillFromDOM(d.code.toUpperCase());
            });

            var i = $('CartDiscountInput');
            if (i) { i.value = code; i.classList.add('is-error'); }

            if (existingBumped) {
              showFeedback(
                '"' + code + '" can\'t be used with your existing discount' + (existing.length > 1 ? 's' : '') + '.',
                'is-error'
              );
            } else {
              showFeedback(
                'Code "' + code + '" is not valid or doesn\'t apply to this cart.',
                'is-error'
              );
            }
          });
        }

        /* ── Case 2: new code IS applicable, but some existing codes got bumped ── */
        refreshSections(data.sections || {});
        updateSavingsBanner(calcSavings(data));

        /* Add new code pill */
        addPill(code);
        var inp2 = $('CartDiscountInput');
        if (inp2) inp2.value = '';

        if (notApplicable.length > 0) {
          /* Remove pills for bumped existing codes and show warning */
          var bumpedNames = [];
          notApplicable.forEach(function (d) {
            var upper = d.code.toUpperCase();
            if (upper !== code) {
              removePillFromDOM(upper);
              bumpedNames.push(upper);
            }
          });

          if (bumpedNames.length > 0) {
            showFeedback(
              'Code "' + code + '" applied. "' + bumpedNames.join('", "') + '" could not be used with this discount and was removed.',
              'is-error'
            );
          } else {
            showFeedback('Code "' + code + '" applied successfully!', 'is-success');
          }
        } else {
          showFeedback('Code "' + code + '" applied successfully!', 'is-success');
        }
      })
      .catch(function (err) {
        console.error('[CartDiscount]', err);
        showFeedback('Something went wrong. Please try again.', 'is-error');
      })
      .finally(function () { setLoading(false); });
  }

  /* ── Remove ───────────────────────────────────────────────────────── */
  function removeDiscount(codeToRemove) {
    clearFeedback();
    var next = currentCodes().filter(function (c) {
      return c.toUpperCase() !== codeToRemove.toUpperCase();
    });

    /* Remove pill immediately for snappy UX */
    removePillFromDOM(codeToRemove);

    updateCartDiscount(next)
      .then(function (data) {
        refreshSections(data.sections || {});
        updateSavingsBanner(calcSavings(data));
        if (next.length === 0) showFeedback('Discount code removed.', 'is-success');
      })
      .catch(function (err) {
        console.error('[CartDiscount]', err);
        showFeedback('Could not remove code. Please try again.', 'is-error');
        window.location.reload();
      });
  }

  /* ── Event binding ────────────────────────────────────────────────── */
  function bindEvents() {
    var btn   = $('CartDiscountApply');
    var inp   = $('CartDiscountInput');
    var pills = $('CartDiscountPills');

    if (btn && !btn._cdBound) {
      btn._cdBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        applyDiscount();
      });
    }

    if (inp && !inp._cdBound) {
      inp._cdBound = true;
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
      });
    }

    if (pills && !pills._cdBound) {
      pills._cdBound = true;
      pills.addEventListener('click', function (e) {
        var rb = e.target.closest('.cd-pill-remove');
        if (rb && rb.dataset.code) removeDiscount(rb.dataset.code);
      });
    }
  }

  /* ── Extra safety: block cart form submit when discount input focused  */
  var cartForm = $('cart');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      if (document.activeElement && document.activeElement.id === 'CartDiscountInput') {
        e.preventDefault();
      }
    });
  }

  /* ── Init savings banner on page load if codes already applied ─────── */
  (function initSavings() {
    var banner = $('CartSavingsBanner');
    if (!banner) return;
    var initial = parseInt(banner.dataset.savingsCents || '0', 10);
    updateSavingsBanner(initial);
  })();

  bindEvents();
})();